const GET_VACANCIES = "job_activities";



export default {
  GET_VACANCIES,

};
